
export const CATEGORY_TYPES = ['Fresh', 'FMCG', 'Other'] as const;
export type CategoryType = typeof CATEGORY_TYPES[number];

export const CATEGORY_TYPE_LABELS: Record<CategoryType, string> = {
  Fresh: 'Fresh',
  FMCG: 'FMCG',
  Other: 'Other'
};

export const CATEGORY_TYPE_COLORS: Record<CategoryType, string> = {
  Fresh: 'bg-green-100 text-green-700',
  FMCG: 'bg-blue-100 text-blue-700',
  Other: 'bg-gray-100 text-gray-700'
};
